import * as angular from 'angular';

import { IDispatcherService, IDispatcher, ITicketStatusActionsService } from '../';
import { TicketType } from '../../models';

export interface ITicketStatusStoreService {
    getAll: (force?: boolean) => angular.IPromise<TicketType[]>;
}

export interface ITicketStatusActionDispatcherService extends IDispatcherService<ITicketStatusStoreService> { }

export class TicketStatusActionDispatcherService implements ITicketStatusActionDispatcherService {
    static serviceId = 'ticketStatusActionDispatcherService';

    static $inject = ['ticketStatusActionsService'];

    constructor(private _actionService: ITicketStatusActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<ITicketStatusStoreService> {
        return {
            dispatcher: {
                getAll: (force?: boolean) => dispatch(this._actionService.getAll(force)),
            }
        };
    }
}